import { AUTH_TYPES, TEMPLATE_CATEGORIES } from './constants.js'

export const mailchimpTemplate = {
	id: 'mailchimp',
	guid: '1a0b4e7d-b9c8-47c2-8232-09e798b1782e',
	name: 'Mailchimp',
	category: TEMPLATE_CATEGORIES.MARKETING,
	popularity: 'Popular',
	color: '#ffe01b',
	iconColor: '#000',
	icon: 'mdi-mailbox',
	description: 'Email marketing platform for newsletters, campaigns, and audience management.',
	features: ['API Key Auth', 'List Management', 'Campaign Tracking', 'Audience Segmentation'],
	configFields: [
		{ name: 'apiKey', label: 'API Key', type: 'password', required: true, placeholder: 'Enter your Mailchimp API key' },
		{ name: 'serverPrefix', label: 'Server Prefix', type: 'text', required: true, placeholder: 'e.g. us1, us2 (from api endpoint)' },
		{ name: 'listId', label: 'Audience ID', type: 'text', required: true, placeholder: 'Enter your Mailchimp list/audience ID' }
	],
	endpoints: [
		{
			name: 'Add member to list',
			url: 'https://{server-prefix}.api.mailchimp.com/3.0/lists/[PLACEHOLDER_CHANNELID]/members',
			method: 'POST',
			description: 'Add or update a list member',
			cassieObjectID: -5,
			incrementField: 'preferenceID',
			resetIncrementValue: false,
			fields: [
				{ name: 'Email1', filter: '' },
				{ name: 'ConsentDate', filter: '' },
				{ name: 'URN1', filter: '' },
				{ name: 'Forename', filter: '' },
				{ name: 'Surname', filter: '' }
			],
			requestBody: '{ "email_address": "[PLACEHOLDER_EMAIL1]", "status_if_new": "subscribed", "merge_fields": { "FNAME": "[PLACEHOLDER_FORENAME]", "LNAME": "[PLACEHOLDER_SURNAME]" } }',
			headers: [{ Name: 'Authorization', value: 'Bearer [APIKEY]' }],
			successResponses: [{ code: 200, message: '' }]

		}
	],
	defaults: {
		endpointAddress: 'https://[server].api.mailchimp.com/3.0',
		authenticationTypeId: AUTH_TYPES.API_KEY,
		frequencyInSeconds: 0,
		notes: 'Mailchimp email marketing integration for managing campaigns, lists, and audience engagement. Replace [server] with your Mailchimp server prefix (e.g., us1, us2, etc.).'
	}
}
